import { makeStyles } from "@material-ui/styles";

const gameClockViewStyles = makeStyles(() => ({
	clockText: {
		fontSize: ({ size }) => {
			return size === "small" ? 24 : 40;
		},
		// Tabular figures keep every digit the same width so the clock
		// doesn't shrink/expand as the time ticks
		fontVariantNumeric: "tabular-nums",
		fontFeatureSettings: "'tnum'"
	}
}));

export default gameClockViewStyles;
